import { FC, useState } from "react";
import { Alert, AlertColor, Box, Button } from "@mui/material";

type ReportAlertProps = {
  report: string[];
  severity: AlertColor;
  textDescription: string;
};

export const ReportAlert: FC<ReportAlertProps> = ({
  report,
  severity,
  textDescription,
}) => {
  const [displayList, setDisplayList] = useState(false);
  return (
    <Box>
      <Alert severity={severity}>
        <Box>
          {report.length} {textDescription}
        </Box>
        <Box mt={1}>
          <Button
            color={severity}
            variant="outlined"
            size="small"
            onClick={() => setDisplayList(!displayList)}
          >
            {displayList ? "Hide" : "Show"} list
          </Button>
        </Box>
        {displayList && (
          <Box pt={1}>
            {report.map((email) => (
              <Box key={email}>{email}</Box>
            ))}
          </Box>
        )}
      </Alert>
    </Box>
  );
};
